import React, { useState } from 'react'
import TourGuide from 'components/TourGuide'

function App() {
  const [message, setMessage] = useState('你好！欢迎来到这个简单的React页面。')
  const [isExpanded, setIsExpanded] = useState(false)

  const toggleMessage = () => {
    setIsExpanded((prev) => !prev)
    setMessage((prev) =>
      prev === '点击按钮查看更多内容！'
        ? '你好！欢迎来到这个简单的React页面。这是一个只用一个按钮控制的React应用。'
        : '点击按钮查看更多内容！'
    )
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        backgroundColor: '#f0f2f5'
      }}
    >
      <h1>单按钮React示例</h1>

      <p
        style={{
          marginBottom: '30px',
          color: 'rgba(0, 0, 0, 0.8)',
          transition: 'max-height 0.5s ease',
          maxHeight: isExpanded ? '1000px' : '20px',
          overflow: 'hidden'
        }}
      >
        {message}
      </p>
      <TourGuide>
        <button
          onClick={toggleMessage}
          style={{
            padding: '12px 24px',
            fontSize: '16px',
            backgroundColor: '#1890ff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
          }}
        >
          {isExpanded ? '收起' : '展开'}
        </button>
      </TourGuide>
    </div>
  )
}

export default App
